import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

/**
 * Service implementation to replace special characters wherever needed.
 */
export class TextProcessorService {

  private replacements = new Map<RegExp, string>([
    [new RegExp(/[ä]/g), 'ae'],
    [new RegExp(/[ö]/g), 'oe'],
    [new RegExp(/[ü]/g), 'ue'],
    [new RegExp(/[Ä]/g), 'Ae'],
    [new RegExp(/[Ö]/g), 'Oe'],
    [new RegExp(/[Ü]/g), 'Ue'],
    [new RegExp(/[ß]/g), 'ss'],
    [new RegExp(/[\\\/:\*\?"<>\|\.\-]/g), '_'],
    [new RegExp(/\s/g), '_'],
    [new RegExp(/[^a-zA-Z0-9_\-]/g), ''] // everything else except letters, numbers and '_' '-'
  ]);

  private _specialNumbersInElements = new Map<RegExp, string>([
    [new RegExp(/[₀]/g), '0'],
    [new RegExp(/[₁]/g), '1'],
    [new RegExp(/[₂]/g), '2'],
    [new RegExp(/[₃]/g), '3'],
    [new RegExp(/[₄]/g), '4'],
    [new RegExp(/[₅]/g), '5'],
    [new RegExp(/[₆]/g), '6'],
    [new RegExp(/[₇]/g), '7'],
    [new RegExp(/[₈]/g), '8'],
    [new RegExp(/[₉]/g), '9']
  ]);

  /**
   * Replaces umlauts and other special characters.
   * Whitespaces will be removed as well.
   */
  public replaceSpecialChars(text: string): string {
    if (!text || text.length === 0) {
      return '';
    }
    this.replacements.forEach((replacement: string, regex: RegExp) => {
      text = text.replace(regex, replacement);
    });
    return text;
  }

  public replaceSpecialNumbersInElements(text: string): string {
    if (!text || text.length === 0) {
      return '';
    }
    this._specialNumbersInElements.forEach((replacement: string, regex: RegExp) => {
      text = text.replace(regex, replacement);
    });
    return text;
  }
}
